import toast from 'react-hot-toast';
import getWarningOptions from '../utils/getWarningOptions';
import parseMessage from '../utils/parseMessage';

const warning = (message, options) =>
  toast(parseMessage(message), getWarningOptions(options));

export default warning;
